import {useMutation, useQueryClient} from 'react-query'
import {Toast} from '../../../../../../../_metronic/partials/widgets'
import {deleteSubtask} from '../../core/_requests'
import {QUERIES} from '../../../../../../../_metronic/helpers'
import {useSearchParams} from 'react-router-dom'

export function useDeleteSubtask() {
  const queryClient = useQueryClient()
  const theme = window.localStorage.getItem('kt_theme_mode_value') || ''
  const [searchParams, setSearchParams] = useSearchParams()

  return useMutation(async (id: number) => deleteSubtask(id), {
    onSuccess: (data, id) => {
      Toast.fire({
        icon: 'success',
        title: 'Subtarefa desvinculada com sucesso.',
        customClass: {
          popup: 'bg-light-success',
          title: theme === 'dark' ? 'text-dark' : 'text-success',
        },
      })

      queryClient.setQueryData(
        [`${QUERIES.TASKS_LIST}-task-${searchParams.get('taskId')}`],
        (task: any) => {
          const updatedSubtasks = task.tasks.subtasks.filter((subtask: any) => subtask.id != id)

          return {
            ...task,
            tasks: {
              ...task.tasks,
              subtasks: [...updatedSubtasks],
            },
          }
        }
      )

      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === 'string' && query.queryKey[0].startsWith(QUERIES.TASKS_LIST),
      })
    },
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: theme === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })
}
